<template>
  <!-- Hero -->
  <section class="bg-mainBlue">
    <div class="u-container">
      <div class="bg-white rounded-xl px-6 py-8 xl:py-10 xl:px-20">

        <!-- =======================
        === SERVICIO SHOPPER (ID 2)
        ======================== -->
        <article
          :class="typeService === 2 ? 'grid' : 'hidden'"
          class="xl:grid-cols-2 gap-20"
        >
          <div class="">
            <header
              class="bg-gray-200 xl:bg-white p-4 xl:p-0 rounded-full ring ring-gray-100 xl:ring-transparent flex gap-6 justify-around xl:justify-start mb-6 font-semibold text-xs xl:text-base relative underline"
            >
              <button type="button" :aria-pressed="typeService === 1"
                @click.prevent="changeServiceForm(1)"
                class="z-10 flex gap-2 item-center text-gray-400 hover:text-mainOrange transition-colors cursor-pointer"
              >
                <img
                  src="../../assets/icons/SERVICIO-COURIER-1.png"
                  class="hidden xl:block w-6 h-6"
                />
                Servicio Courier
              </button>

              <button type="button" :aria-pressed="typeService === 2"
                class="z-10 flex gap-2 item-center text-mainOrange hover:text-mainOrange transition-colors cursor-pointer"
              >
                <img
                  src="../../assets/icons/SERVICIO-SHOPPER-2.png"
                  class="hidden xl:block w-6 h-6"
                />
                Servicio Shopper
              </button>

              <div class="absolute w-1/2 rounded-full top-0 bottom-0 right-0 border border-mainOrange xl:hidden transition-all bg-white"></div>
            </header>



            <h1 class="text-bg-black-blue mb-6 text-xl xl:text-4xl font-bold">
              Sendi Shopper compra por ti en EE.UU. y lo trae a Perú
            </h1>

            <p class="mb-8 text-sm xl:text-base">
              Importa sin tarjeta internacional y sin complicaciones.
              Envíanos el link del producto y nosotros nos encargamos de comprarlo, traerlo a Perú y entregártelo.
              <br />
              <strong>Precio final transparente antes de pagar.</strong>
            </p>

            <label class="font-semibold text-xs xl:text-sm block mb-1"
              >Pega aquí el link del producto o escribe su nombre</label
            >

            <form>
              <div class="relative mb-8">
                <img
                  src="../../assets/icons/icon-search-orange.png"
                  class="absolute left-6 bottom-4 cursor-pointer"
                />
                <input
                  type="text"
                  :class="shooper.error ? 'ring ring-mainRed' : ''"
                  v-model="shooper.name"
                  placeholder="Ejemplo: “https://www.amazon.com/…” o “MacBook Pro 14 M3”"
                  class="text-textColor py-4 pl-16 px-8 rounded-xl w-full border bg-gray-100 bg-opacity-50 focus:outline-none focus:ring focus:ring-mainOrange"
                />
              </div>
              <ul class="mb-4 text-xs xl:text-sm text-gray-700 space-y-1">
                <li>✔ Nosotros compramos por ti</li>
                <li>✔ Precio final claro antes de pagar</li>
                <li>✔ Seguimiento online en tiempo real</li>
                <li>✔ Entrega en Lima o a domicilio</li>
              </ul>
              <button
                @click.prevent="searchProduct"
                class="font-semibold block w-full xl:w-1/2 rounded-xl py-4 bg-mainGreenLight text-white"
              >
                COTIZAR GRATIS
              </button>

              <p class="mt-4 text-xs xl:text-sm text-gray-600 text-left">
                Te mostraremos un estimado del costo final. Sin compromiso.
              </p>

              
            </form>
          </div>

          <img src="../../assets/images/2-sendi.png" class="ml-auto hidden xl:block" />
        </article>

        <!-- =======================
        === SERVICIO COURIER (ID 1)
        ======================== -->
        <article
          :class="typeService === 1 ? 'grid' : 'hidden'"
          class="xl:grid-cols-2 gap-20"
        >
          <div class="">
            <header
              class="bg-gray-200 xl:bg-white p-4 xl:p-0 rounded-full ring ring-gray-100 xl:ring-transparent flex gap-6 justify-around xl:justify-start mb-6 font-semibold text-xs xl:text-base relative underline"
            >
              <button type="button" :aria-pressed="typeService === 1"
                class="z-10 flex gap-2 item-center text-mainOrange hover:text-mainOrange transition-colors cursor-pointer"
              >
                <img
                  src="../../assets/icons/SERVICIO-COURIER-1.png"
                  class="hidden xl:block w-6 h-6"
                />
                Servicio Courier
              </button>

              <button type="button" :aria-pressed="typeService === 2"
                @click.prevent="changeServiceForm(2)"
                class="z-10 flex gap-2 item-center text-gray-400 hover:text-mainOrange transition-colors cursor-pointer"
              >
                <img
                  src="../../assets/icons/SERVICIO-SHOPPER-2.png"
                  class="hidden xl:block w-6 h-6"
                />
                Servicio Shopper
              </button>

              <div class="absolute w-1/2 rounded-full top-0 bottom-0 left-0 border border-mainOrange xl:hidden transition-all bg-white"></div>
            </header>

            <!-- TITULO NUEVO -->
            <h2 class="text-bg-black-blue mb-6 text-xl xl:text-4xl font-bold">
              Cotiza tu envío desde EE.UU. a Perú
            </h2>

            <!-- DESCRIPCIÓN NUEVA -->
            <p class="mb-8 text-sm xl:text-base">
              Calcula cuánto te costará importar a Perú tu producto comprado en Amazon, eBay, Walmart, Best Buy, Apple o cualquier tienda de EE.UU.
              <br />
              <strong>Sin registro. 100% gratis. Resultado instantáneo.</strong>
            </p>

            <!-- FORMULARIO -->
            <form @submit.prevent="processCourier">
              <div>
                
                <div class="sendi-quote-fields">
                  <div>
                    <label for="quote-price">Precio del producto (USD)</label>
                    <input id="quote-price" type="number" min="0.01" step="0.01" required inputmode="decimal" placeholder="0.00" v-model="courier.precio" @keydown="typeNumber" :aria-invalid="errorCourier.precio || undefined" aria-describedby="quote-price-help quote-price-error" />
                    <p id="quote-price-help" class="sendi-field-help">Precio que aparece en la tienda, en dólares.</p>
                    <p id="quote-price-error" class="sendi-field-error" v-if="errorCourier.precio" role="alert">Ingresa un precio mayor que cero.</p>
                  </div>
                  <div>
                    <label for="quote-weight">Peso estimado</label>
                    <div class="sendi-weight-row">
                      <input id="quote-weight" type="number" min="0.001" step="any" required inputmode="decimal" placeholder="0.00" v-model="courier.peso" @keydown="typeNumber" :aria-invalid="errorCourier.peso || undefined" aria-describedby="quote-weight-help quote-weight-error" />
                      <select id="quote-unit" aria-label="Unidad de peso" v-model="courier.unidad" @change="changeUnit(courier.unidad)">
                        <option value="kg">kg</option><option value="lb">lb</option><option value="oz">oz</option>
                      </select>
                    </div>
                    <p id="quote-weight-help" class="sendi-field-help">Si no lo conoces, puedes estimarlo. Validaremos el peso al recibir el paquete.</p>
                    <p id="quote-weight-error" class="sendi-field-error" v-if="errorCourier.peso" role="alert">Ingresa un peso mayor que cero.</p>
                  </div>
                </div>
              </div>

              <div class="flex items-center gap-4 mb-3">
                <input type="checkbox" class="cursor-pointer w-4 h-4 block" id="paquete" v-model="cotzacionAvanzada" aria-describedby="package-help" />
                <label for="paquete" class="cursor-pointer text-sm xl:text-base font-medium">Estoy cotizando un paquete con varios productos</label>
              </div>
              <p id="package-help" class="sendi-field-help mb-8">Úsalo si recibirás varios artículos en una sola caja.</p>

              <!-- BOTÓN: su tamaño original -->
            <button
              type="submit"
              class="font-semibold block w-full xl:w-1/2 rounded-xl py-4 bg-mainGreenLight text-white"
            >
              COTIZAR GRATIS
            </button>

            <!-- TEXTO DEBAJO: ancho completo, alineado a la izquierda -->
            <p class="mt-4 text-xs xl:text-sm text-gray-600 text-left w-full">
              Te mostraremos un estimado del costo final del envío. Sin compromiso.
            </p>



            </form>
          </div>

          <img src="../../assets/images/3-sendi.png" class="ml-auto hidden xl:block" />
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["typeService"],
  data() {
    return {
      cotzacionAvanzada: false,
      errorCourier: {
        peso: false,
        precio: false,
      },
      courier: {
        peso: "",
        precio: "",
        unidad: "kg",
      },
      shooper: {
        name: "",
        error: false,
      },
      popUp: false,
      popUp2: false,
    };
  },
  methods: {
    typeNumber($event) {
      const val = $event.target.value;
      if (val.includes(".")) {
        const dotIndex = val.indexOf(".");
        const diferencia = val.length - dotIndex;
        if (diferencia > 2 && $event.key !== "Backspace" && $event.key !== "Tab") {
          $event.preventDefault();
        }
      }
    },

    validateDataCourier() {
      this.styleErrorCourier();

      if (
        this.courier.peso &&
        this.courier.precio &&
        this.courier.unidad &&
        this.courier.peso != 0 &&
        this.courier.precio != 0
      ) {
        return true;
      }

      this.$store.state.alert.titulo = "Validación";
      this.$store.state.alert.description = "Ingrese los datos solicitados";
      this.$store.state.alert.estado = true;
      return false;
    },

    styleErrorCourier() {
      this.errorCourier.peso = !this.courier.peso;
      this.errorCourier.precio = !this.courier.precio;
    },

    processCourier() {
      if (this.validateDataCourier()) {
        this.$router.push({
          name: "Courier",
          params: {
            precio: this.courier.precio,
            peso: this.courier.peso,
            unidad: this.courier.unidad,
            typeCotizacion: this.cotzacionAvanzada,
          },
        });
      }
    },

    changeUnit(unit) {
      this.courier.unidad = unit;
    },

    searchProduct() {
      if (this.validateNameShooper()) {
        this.$router.push({
          name: "SearchShooper",
          params: { name: this.shooper.name },
        });
      }
    },

    validateNameShooper() {
      const ok = this.shooper.name.length > 0;
      this.shooper.error = !ok;
      return ok;
    },

    changeServiceForm(id) {
      this.$emit("changeService", id);
      window.localStorage.setItem("servicio", id);
    },
  },

  watch: {
    "shooper.name"() {
      this.shooper.error = false;
    },
    "courier.precio"() {
      this.errorCourier.precio = false;
    },
    "courier.peso"() {
      this.errorCourier.peso = false;
    },
  },
};
</script>
